import DOMPurify from 'dompurify';

// Video embeds reporters can add through the editor; any other iframe is removed
const ALLOWED_IFRAME_HOSTS = [
  'www.youtube.com',
  'youtube.com',
  'www.youtube-nocookie.com',
  'player.vimeo.com',
];

DOMPurify.addHook('uponSanitizeElement', (node, data) => {
  if (data.tagName !== 'iframe') return;
  let host = '';
  try {
    host = new URL(node.getAttribute('src') || '', window.location.href).hostname;
  } catch (_) {}
  if (!ALLOWED_IFRAME_HOSTS.includes(host)) node.parentNode?.removeChild(node);
});

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  // Links opening a new tab must not get access to window.opener
  if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

/**
 * Clean article HTML (scraped from other sites or written in the editor)
 * before rendering it with dangerouslySetInnerHTML.
 */
export function sanitizeHtml(html) {
  return DOMPurify.sanitize(html || '', {
    ADD_TAGS: ['iframe'],
    ADD_ATTR: ['target', 'allow', 'allowfullscreen', 'frameborder'],
    // A <style> block would restyle the whole page, not just the article
    FORBID_TAGS: ['style'],
  });
}
